import request from '@/utils/request'

export function listMaterials(courseId) {
  return request({
    url: '/amc/material/list',
    method: 'get',
    params: { courseId }
  })
}

export function uploadMaterial(courseId, file, title) {
  const form = new FormData()
  form.append('courseId', courseId)
  if (title) form.append('title', title)
  form.append('file', file)
  return request({
    url: '/amc/material/upload',
    method: 'post',
    data: form
  })
}

export function deleteMaterial(id) {
  return request({
    url: `/amc/material/${id}`,
    method: 'delete'
  })
}
